module.exports = __webpack_public_path__ + "static/img-4-a724eb954e85c635d7f8128da03d2759.jpg";